import companiesApi from "./companiesApi";
import companyBranchesApi from "./companyBranchesApi";

export const isBranchId = (value) => /^[0-9a-fA-F]{24}$/.test(String(value || ""));

const questionnaireScopeApi = {
  getById: async (id) => {
    if (isBranchId(id)) {
      const branch = await companyBranchesApi.getById(id);
      return { ...branch, scopeType: "branch" };
    }

    const company = await companiesApi.getCompanyById(id);
    return { ...company, scopeType: "company" };
  },
};

export default questionnaireScopeApi;
